import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { GoogleService } from 'src/app/services/auth/google/google.service';
import { LinkedinService } from 'src/app/services/auth/linkedin/linkedin.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { UserService } from 'src/app/services/user/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  showPassword = false;
  email: string = '';
  password: string = '';
  private redirectUrl: string | null = null;

  constructor(
    private linkedIn: LinkedinService,
    private google: GoogleService,
    private authService: AuthService,
    private userService: UserService,
    private loader: LoadingService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params) => {
      if (params['redirectUrl']) {
        this.redirectUrl = params['redirectUrl'];
        localStorage.setItem('redirectUrl', this.redirectUrl || '/');
      }
    });
  }


loginAsUser() {
  if (!this.email || !this.password) {
    document.querySelectorAll('input').forEach(el => el.dispatchEvent(new Event('blur')));
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Please enter your email and password',
      confirmButtonColor: '#D0385E',
    });
    return;
  }

  const user = { email: this.email, password: this.password };

  this.loader.showLoading();
  this.authService.loginAsUser(user).subscribe(
    (response: any) => {
      this.loader.hideLoading();

      let data: any;
      try {
        data = JSON.parse(response);
      } catch {
        data = response;
      }

      if (data && typeof data === 'object' && data.accessToken) {
        this.userService.setTokenInfo(
          data.accessToken,
          data.refreshToken,
          data.userId,
          data.role
        );
        this.userService.getUserData().subscribe((res: any) => {
          const userInfo = res
            ? {
                email: res.email,
                name: res.name,
                role: data.role,
                picture: res.pictureUrl,
              }
            : {
                email: this.email,
                name: this.email.split('@')[0],
                role: data.role,
                picture: null,
              };
          this.userService.setUserInfo(userInfo);
        });

        const url = localStorage.getItem('redirectUrl');
        localStorage.removeItem('redirectUrl');

        const roleRaw = data.role;
        const roleName = typeof roleRaw === 'object' && roleRaw !== null
          ? roleRaw.name
          : roleRaw;
        const isCompany = roleName?.toString().toUpperCase() === 'COMPANY';

        if (url && url !== '/') {
          this.router.navigate([url]);
        } else if (isCompany) {
          this.router.navigate(['/company-home']);
        } else {
          this.router.navigate(['/home']);
        }
      } else {
        const text = typeof data === 'string' ? data.toLowerCase() : '';
        if (text.includes('email not found')) {
          Swal.fire({
            icon: 'warning',
            title: 'Email not found',
            text: 'This email is not registered. Do you want to create an account?',
            showCancelButton: true,
            confirmButtonText: 'Sign Up',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#D0385E',
            cancelButtonColor: '#6c757d',
          }).then((result) => {
            if (result.isConfirmed) this.router.navigate(['/sign-up']);
          });
        } else if (text.includes('invalid password')) {
          Swal.fire({
            icon: 'error',
            title: 'Login Failed',
            text: 'Incorrect password. Please try again.',
            confirmButtonColor: '#D0385E',
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Login Failed',
            text: 'Invalid email or password',
            confirmButtonColor: '#D0385E',
          });
        }
      }
    },
    (error) => {
      this.loader.hideLoading();
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: 'Something went wrong. Please try again.',
        confirmButtonColor: '#D0385E',
      });
    }
  );
}

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  loginWithLinkedIn() {
    this.linkedIn.loginWithLinkedIn();
  }

  loginWithGoogle() {
    this.google.login();
  }
}